exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsection[data-v-c9f9743e] {\n\tdisplay: inline-flex;\n\tflex: 1 1 auto;\n\tcolor: #615e83;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 20px;\n\talign-items: center;\n\tpadding: 5px;\n}\n.key[data-v-c9f9743e] {\n\twidth: 15px;\n\theight: 15px;\n\tmargin-right: 10px;\n\tdisplay: inline-block;\n\tborder-radius: 10px;\n}\np[data-v-c9f9743e] {\n\tdisplay: inline-flex;\n\tflex: 1 1 auto;\n\tmargin-bottom: 0;\n}\n", ""]);

// exports
